module.exports = __webpack_public_path__ + "img/mine-active.cf8b5beb.png";